// extracted by mini-css-extract-plugin
module.exports = {"scroll-section":"hAC5XZpALG-3N7ANFM4EV"};